import { InjectionToken } from '@angular/core';

export namespace NDfModuleKlevuSearch {
    export const DEFAULT_OPTIONS: IModuleOptions = {
        limit: 1000
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_MODULE_KLEVU_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_OPTIONS
    });

    export interface IModuleOptions {
        limit?: number;
    }
}
